export enum EduTradingCryptoCalendarPeriod {

    ThisWeek = "this-week",
    NextWeek = "next-week",
    ThisMonth = "this-month",
    NextMonth = "next-month",
}
